import { SET_IS_GLOBAL_DOWNLOADING } from "./mutation-types";

const mutations = {
  [SET_IS_GLOBAL_DOWNLOADING](state, isDownloading) {
    state.isGlobalDownloading = isDownloading;
  },
};

export default mutations;
